import apiService from './api-service'

const entriesService = {}

/**
 * Create a entry.
 * @param  {string} creatorType
 * @param  {object} body
 * @return {Promise}
 */
entriesService.post = function (creatorType, body) {
  switch (creatorType) {
    case 'prospect':
      return apiService.post(`/prospects/entry`, body).then(res => res.data)
    default:
      throw Error('Invalid creator type for entry.')
  }
}

export default entriesService



// WEBPACK FOOTER //
// ./src/services/entries.js